var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80288 2.18671C8.50446 2.18671 11.3108 8.50092 11.3108 9.2025C11.3108 10.6057 9.20604 12.0088 8.50446 13.412C7.80288 14.8151 9.20604 16.2183 10.6092 17.6214C11.1625 18.1747 13.4155 20.4278 14.8187 19.7262C16.2218 19.0246 17.625 16.9199 19.0281 16.9199C19.7297 16.9199 26.0439 19.7262 26.0439 20.4278C26.0439 23.2341 23.9392 25.3388 21.8345 26.0404C19.7297 26.742 18.3266 26.742 15.5202 26.0404C12.7139 25.3388 10.6092 24.6372 7.1013 21.1293C3.59341 17.6214 2.89183 15.5167 2.19025 12.7104C1.48867 9.90408 1.48867 8.50092 2.19025 6.39618C2.89183 4.29144 4.99656 2.18671 7.80288 2.18671Z",
    stroke: "white",
    strokeWidth: 2.80632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9648 7.25189C19.0031 7.71727 19.9401 8.36147 20.734 9.14409C21.5074 9.90634 22.1453 10.7999 22.6094 11.7875",
    stroke: "white",
    strokeWidth: 2.80632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5686 10.253C28.002 8.10369 26.8546 6.18224 25.2992 4.65782C23.733 3.12282 21.7534 1.99039 19.5371 1.43335",
    stroke: "white",
    strokeWidth: 2.80632,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a13f4e63e592bc2cfcf383273d35d4fb.svg";
export { ForwardRef as ReactComponent };